'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function () {
  var Snap = undefined;
  try {
    Snap = require('snapsvg-cjs');
  } finally {
    return Snap;
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-burger-menu/lib/snapsvgImporter.js
// module id = ./node_modules/react-burger-menu/lib/snapsvgImporter.js
// module chunks = 5 6